import React from 'react'
import { Trans, t } from '@lingui/macro'
import { staticLinks } from 'shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import { ButtonPrimary, Box, Heading } from 'front-end/src/components'
import { notification } from '../../../components/common/notifications/Notifications'
import { useParams } from 'react-router-dom'
import { useSetNewPasswordMutation } from 'front-end/src/pages/auth/reset-password/ResetPassword.codegen'
import { Formik } from 'formik'
import { PasswordField } from 'front-end/src/pages/auth/self-signup/fields/PasswordField'
import IconArrowRight from 'front-end/src/components/common/icon/IconArrowRight'
import {
  getValidationSchemaForUserFields,
  UserExtraValidationSchemaEnum
} from 'shared/entities-validator/user-fields-validators'
import * as yup from 'yup'
import { omit } from 'lodash'
import { brandColors } from 'shared/basicPalette'

const ResetPasswordForm = () => {
  const { userId, token } = useParams<{ userId: string; token: string }>()
  const [resetPassword, { loading }] = useSetNewPasswordMutation({
    onCompleted: (data) => {
      if (data?.resetPassword.userIdentity) {
        notification.info(
          t`Password successfully updated for ${data.resetPassword.userIdentity}`
        )
      }
      navigateTo(staticLinks.login)
    }
  })

  return (
    <Box className="Auth">
      <Box className="Auth__container">
        <Heading size="md" mb="24px">
          <Trans>Now you can set your new password</Trans>
        </Heading>

        <Formik
          onSubmit={async (formData) => {
            await resetPassword({
              variables: {
                userId: Number(userId),
                password: formData.password,
                token
              }
            })
          }}
          validateOnMount
          initialValues={{
            password: '',
            passwordConfirmation: ''
          }}
          validationSchema={yup.object().shape(
            omit(
              getValidationSchemaForUserFields({
                requiredFields: [
                  UserExtraValidationSchemaEnum.PASSWORD,
                  UserExtraValidationSchemaEnum.PASSWORD_CONFIRMATION
                ],
                errorMessages: {
                  passwordValidationMessage: t`Passwords must be at least 8 characters containing both letters and numbers.`,
                  defaultNonNullMessage: t`must not be empty`,
                  bothPasswordNeedToBeTheSameMessage: t`Both password need to be the same`
                },
                requireAdditionalFields: false
              }),
              'email'
            )
          )}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <PasswordField />

              <ButtonPrimary
                disabled={!isValid || loading}
                type="submit"
                isFullWidth
                mt="28px"
                rightIcon={<IconArrowRight />}
              >
                <span className="btn__text">
                  <Trans>Next</Trans>
                </span>
              </ButtonPrimary>
            </form>
          )}
        </Formik>

        <Box textAlign="center" mt="32px">
          <Box
            color={brandColors.grey['700']}
            as={'a'}
            href={staticLinks.login}
          >
            <Trans>Cancel</Trans>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ResetPasswordForm
